import React from "react";
import { usePostHog } from "posthog-js/react";

interface GooglePlayButtonProps {
  className?: string;
  darkText?: boolean;
}

const GooglePlayButton: React.FC<GooglePlayButtonProps> = ({
  className,
  darkText = false,
}) => {
  const posthog = usePostHog();
  const handleClick = () => {
    posthog?.capture("google_play_button_clicked", {
      url: "https://play.google.com/store/apps/details?id=com.flateroo.flateroo",
    });
  };
  return (
    <a
      href="https://play.google.com/store/apps/details?id=com.flateroo.flateroo"
      className={`flex items-center ${
        className || (darkText ? "bg-gray-900/10" : "bg-gray-100/20")
      } ${
        darkText ? "text-black" : "text-white"
      } px-4 py-3 rounded-lg hover:scale-110 transition-transform duration-300`}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src={`${process.env.PUBLIC_URL}/google-play-icon.svg`}
        alt="Google Play Icon"
        className="w-6 h-6 mr-2"
      />
      <span className="text-base font-bold">Google Play</span>
    </a>
  );
};

export default GooglePlayButton;
